import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const RenameIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentcolor">
            {/* eslint-disable-next-line max-len */}
            <path d="M4.49992 15.5H5.28992L13.8718 6.91834L13.0816 6.12813L4.49992 14.71V15.5ZM3.83325 16.1667V14.4215L14.6458 3.5448L16.4712 5.30605L5.57846 16.1667H3.83325ZM13.4697 6.53022L13.0816 6.12813L13.8718 6.91834L13.4697 6.53022Z"/>
        </svg>
    </IconWrapper>
));
